import { ArrowRight } from 'lucide-react';
import * as React from 'react';

import { Button } from '@/components/ui/button';

import { InlineWidgetClient } from '@/lib/calendly/calendly.inline-widget';

import { BookDemoButton } from './book-demo.button';

export function BookDemoSection() {
  return (
    <section className="redesign-container">
      <div className="mx-auto max-w-7xl px-0 py-24 sm:py-32 lg:flex lg:items-center lg:gap-x-10 lg:px-8 lg:py-40">
        <div className="mx-auto max-w-xl lg:mx-0 lg:flex-auto">
          <h1 className="mt-10 text-5xl font-black tracking-tight text-pretty sm:text-7xl max-w-[9ch]">
            Skip the{' '}
            <span className="text-primary italic relative">sales pitch</span>
          </h1>
          <p className="mt-8 text-lg font-medium text-pretty text-muted-foreground sm:text-xl/8">
            See how FlagSync handles flags, rollouts, and experiments. No
            pressure, just a fast, technical look at what FlagSync can do.
          </p>

          <div className="mt-10 flex flex-col md:flex-row items-center gap-y-2 md:gap-x-6">
            <BookDemoButton />
            <Button
              asChild
              variant="link"
              className="uppercase w-full md:w-fit flex-shrink-0"
            >
              <a
                href="https://docs.flagsync.com"
                className="inline-flex items-center"
              >
                View Docs
                <ArrowRight className="ml-2 w-4 h-4" />
              </a>
            </Button>
          </div>
        </div>
        <div className="mt-16 sm:mt-24 lg:mt-0 lg:shrink-0 lg:grow">
          <InlineWidgetClient />
        </div>
      </div>
    </section>
  );
}
